import { Reportable } from "../Reports/ReportCreation";

export enum Gender {
  MALE="MAN",
  FEMALE="WOMAN"
}


export interface GetCompetitionsDto {
    competitions: Array<Competition>;
}

export interface GetParticipantDto {
    participants: Array<Participant>;
}

export interface GetDisciplineDto {
    id: number;
    name: string;
    displayOrder: number; 
    minAge: number | null;
    maxAge: number | null;
    groupSize: number| null; // Not needed? Not enforced anymore (was enforced 2024)
    startNumberSequences: Array<StartNumberSequence>
    distanceInMeters: number;
    resultType: ResultType;
}

export interface StartNumberSequence {
    firstStartNumber: number,
    lastStartNumber: number
}

export interface GetResultsDto {
    results: Array<Result>;
}


export interface CompetitionIdAndTagDto {
    id: number;
    tag: string;
}

export interface CompetitionDto extends CompetitionIdAndTagDto {
    startTime: number | null;
    endTime: number | null;
}

export interface Competition {
    id: number;
    tag: string;
    startTime: number | null;
    endTime: number | null;
    disciplines: Array<Discipline>; 
    startgroups: Array<Startgroup>; // All startgroups in the timeframe of the competition regardless of if they are assigned to discipline or not
    //name: string;
    //description: string; // Deprecated. Not needed in this app. Remove from DTO
    //start_time: number; // Deprecated. Not needed in this app. Remove from DTO
    //end_time: number;  // Deprecated. Not needed in this app. Remove from DTO
    //deleted: boolean;  // Deprecated. Not needed for this app? In that case lets remove it from the DTO to keep the code simpler. OBS: does not matter if inkluded in DTO from backend or not!
}

export interface ParticipantDto {
    id: number;
    firstname: string;
    lastname: string;
    startnumber: number | null;
    disciplineId: number;
    startgroupId: number | null;
    birthYear: number;
    clubOrTeam: string;
    distanceInMeters: number;
    gender: Gender | null;
}

export interface Participant extends Reportable {
    id: number;
    firstname: string;
    lastname: string;
    startnumber: number | null;
    disciplineId: number;
    startgroupId: number | null;
    birthYear: number;
    clubOrTeam: string;
    distanceInMeters: number;

    // Reportable
    disciplineName: string;
    startgroup: Date | null;
    gender: Gender | null;
}

export enum ResultType {
    INDIVIDUAL = "INDIVIDUAL",
    GROUP = "GROUP"
}


export interface Discipline {
    id: number;
    name: string;
    displayOrder: number; 
    minAge: number | null;
    maxAge: number | null;
    groupSize: number | null; // Not needed?
    resultType: ResultType;
    startNumberSequences: Array<StartNumberSequence>
    distanceInMeters: number;
    startgroups: Array<Startgroup>;
}

export interface Startgroup {
    id: number;
    starttime_planned: number;
    starttime_actual: number | null;
    closetime_planned: number;
    closetime_actual: number | null;
}
export interface DisciplineStartgroupMapDto {
    id: number;
    disciplineId: number;
    startgroupId: number;
}

export interface LotteryDto {
    id: number;
    competitionId: number;
    name: string;
    disciplinesCond: string;
    completedCond: boolean;
    startnumberSequencesCond: string;
    teamNameCond: string;
    description: string;
    nrOfWinners: number;
}    

export interface LotteryWinnersDto {
     id: number;
     lotteryId: number;
     startnumber: number; // En vinnares startnummer
     name: string;
     birthYear: number; // En vinnares födelseår
     clubOrTeam: string;
}

export interface AddParticipantModalProps {
    isOpen: boolean;
    onClose: () => void;
    onAddRow: (newRow:  {id: number, startnumber: number, klass: string, firstname: string, lastname: string, birthYear: number, clubOrTeam: string,// dns: boolean, dnf: boolean 
    }) => void;
 }
  
export interface AddStartgroupModalProps {
    isOpen: boolean;
    onClose: () => void;
    onAddRow: (newRow:  {id: number, starttime_planned: number, starttime_actual: number | null, closetime_planned: number, closetime_actual: number | null }) => void;
}

export interface AddDisciplineModalProps {
    isOpen: boolean;
    onClose: () => void;
    onAddRow: (newRow:  {id: number, name: string, description: string, display_order: number, group_size: number, time_type: number }) => void;
}

export interface AddCompetitionModalProps {
    isOpen: boolean;
    onClose: () => void;
    onAddRow: (newRow:  {id: number, tag: string, name: string, classes: Array<Discipline>, description: string, start_time: number, end_time: number, deleted: boolean }) => void;
}
  
export interface AddResultModalProps {
    isOpen: boolean;
    onClose: () => void;
    onAddRow: (newRow:  {finishTime: number, startnumber: number }) => void;
}

export interface AddLotteryModalProps {
    isOpen: boolean;
    onClose: () => void;
    onAddRow: (newRow:  {id: number, competitionId: number, name: string, disciplinesCond: string, completedCond: boolean, startnumberSequencesCond: string, teamNameCond: string, description: string, nrOfWinners: number,  }) => void;
}

export interface AddResultListFrmModalProps {
    isOpen: boolean;
    onClose: () => void;
    onAddRow: (newRow: ResultListFrmDto) => void | Promise<void>;
}

export interface ResultDto {
    id: string;
    firstname: string;
    lastname: string;
    birthYear: number;
    clubOrTeam: string | null;
    startnumber: number;
    startTime: number | null;
    finishTime: number | null;
    distanceInMeters: number | null;

    disciplineName: string;
    startgroupId: number | null;
    gender: Gender | null;
}


export interface ResultList<T> {
    competitionTag: string;
    name: string;
    displayOrder: number;
    showResults: boolean;
    results: Array<T>
}

// Not actually a DTO, using ResultDto as DTO, mapping to this for simplicity
export interface Result extends Reportable {
    id: string;

    firstname: string;
    lastname: string;
    birthYear: number;
    clubOrTeam: string | null;
    startnumber: number;

    startTime: number | null;
    finishTime: number | null;
    distanceInMeters: number | null;

    disciplineName: string;
    startgroup: Date | null;
    gender: Gender | null;
}

export interface StartnumberRfidTag {
    id: number;
    rfidtag: string;
    startnumber: number;
}

export interface RfidFetchResponse {
  antennaReads: Array<AntennaRead>
  responseTimestamp: number;
}

export interface AntennaRead {
  tag: string, antenna: string
}

export interface ResultPostPutDto {
    finishTime: number | null;
    signupId: number | null;
}

export interface ResultPostPutStartnumberDto {
    finishTime: number | null;
    startnumber: number | null;
}

export interface TagreadEntityList {
    tagreadEntitys: Array<TagreadEntity>
}
export interface TagreadEntity {
    id: number;
    createdBy: string;
    creationTime: number;
    lastModifiedBy: string;
    modificationTime: number;
    antennaPort: number;
    epc: string;
    firstSeenTimestamp: number;
    triggerOutput: string;
    startNr: number;
    startGroup: string;
    timeStart: number | null;
    timeChip: number | null;
    heartBeat: boolean;
}

export interface TagreaderModel {
    reader_name: string;
    mac_address: string;
    tag_reads: Array<TagreadModel>;
}

export interface TagreadModel {
    antennaPort: number;
    epc: string;
    firstSeenTimestamp: number;
    isHeartBeat: boolean;
}

export interface DistinctTagreadDto {
    epc: string;
    firstSeenTimestamp: number;
    antennaPort: number;
}

export interface ResultListFrmDto {
    id: number;
    competitionTag: string;
    name: string;
    disciplineName: string;
    displayOrder: number;
    gender: Gender | null;
    showResults: boolean;
    earliestBirthYear: number;
    latestBirthYear: number;
}    